import React, { useState } from 'react'
import * as Header from 'views/ui/Header/Header'
import { AntDHeader } from 'views/ui/Header/Header'
import { useHelmet } from '@agro-club/frontend-shared'
import { ConfigProvider, Flex, Tabs, TabsProps } from 'antd'
import { useTranslation } from 'react-i18next'
import CSS from 'csstype'
import { DeleteOutlined } from '@ant-design/icons'
import './styles.css'
import { Status, UploadCompanyType } from 'types/entities'
import DigitalAssetsListTab from './DigitalAssetList/DigitalAssetsListTab'
import { useSelector } from 'react-redux'
import AuthSelectors from 'modules/domain/auth/selectors'

const digitalAssetsHeaderStyles: CSS.Properties = {
  paddingLeft: '1em',
  paddingRight: '1em',
}

const DigitalAssetsTabsBarStyles: CSS.Properties = {
  paddingLeft: '1.5em',
  paddingRight: '1.5em',
  backgroundColor: '#FFFFFF',
}

const DigitalAssetTabsStyles: CSS.Properties = {
  flexGrow: 1,
  backgroundColor: '#FAFAFA',
}

const tabContainerStyles: CSS.Properties = {
  display: 'flex',
  flex: 1,
}

const DigitalAssetList = (): JSX.Element => {
  const { t } = useTranslation('digitalAsset')
  const [activeKey, setActiveKey] = useState('1')
  useHelmet({ title: t('digitalAssetsMetaTitle') })

  const isAdminOrProducer = useSelector(AuthSelectors.isAdminOrProducer)

  const tabItems: TabsProps['items'] = [
    {
      key: '1',
      label: isAdminOrProducer ? t('tabs.manufacturerAssets') : t('tabs.sharedWithMe'),
      children: <DigitalAssetsListTab uploadCompanyType={UploadCompanyType.Producer} />,
      destroyOnHidden: true,
      style: tabContainerStyles,
    },
    {
      key: '2',
      label: isAdminOrProducer ? t('tabs.retailerAssets') : t('tabs.myAssets'),
      children: <DigitalAssetsListTab uploadCompanyType={UploadCompanyType.Distributor} />,
      destroyOnHidden: true,
      style: tabContainerStyles,
    },
  ]

  //simulating 3rd tab for trash can component
  const rightTabStyles: CSS.Properties = {
    padding: '10px 16px',
    cursor: 'pointer',
    borderBottom: activeKey === '3' ? '2px solid #20b02e' : 'none',
    color: activeKey === '3' ? '#20b02e' : 'inherit',
  }

  const rightTab = (
    <div style={rightTabStyles} onClick={() => setActiveKey('3')}>
      <DeleteOutlined /> {t('tabs.deletedAssets')}
    </div>
  )

  return (
    <>
      <Flex style={digitalAssetsHeaderStyles} justify={'space-between'}>
        <Header.Title title={t('list.heading')} />
        <AntDHeader />
      </Flex>
      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              horizontalMargin: '0',
            },
          },
        }}
      >
        <Tabs
          style={DigitalAssetTabsStyles}
          tabBarStyle={DigitalAssetsTabsBarStyles}
          items={tabItems}
          activeKey={activeKey}
          onChange={setActiveKey}
          tabBarExtraContent={{ right: rightTab }}
          className={activeKey === '3' ? 'hide-ink-bar' : ''}
        />
        {activeKey === '3' && <DigitalAssetsListTab assetStatus={Status.Deleted} />}
      </ConfigProvider>
    </>
  )
}

export default DigitalAssetList
